import React, { Fragment } from 'react';

import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";
import SpinnerDiv from "ui/ReactSpinnerDiv";

const DropdownProviderEYFSGroups = ({ control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, school_id, onChange } ) =>
{
    const fields = { url: '/school/' + school_id + '/_eyfsgroups', keyFieldName: 'raw_group_id', labelFieldName: 'group_name', additionalFields: ['group_id', 'group_type_id'] }

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} onChange={onChange} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownProviderEYFSGroups;
